import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import SearchBox from '@/components/feature/SearchBox';

const navItems = [
  { label: '剧情', path: '/category/plot' },
  { label: '演员', path: '/category/cast' },
  { label: '动态', path: '/category/news' },
  { label: '关于', path: '/about' },
];

export default function SiteHeader() {
  const { pathname } = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const isHome = pathname === '/';
  const transparent = isHome && !scrolled;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  const textColor = transparent ? 'text-background-50' : 'text-foreground-900';

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 w-full transition-all duration-300 ${
        transparent
          ? 'bg-gradient-to-b from-foreground-950/55 to-transparent py-1'
          : 'border-b border-background-200 bg-background-50/95 py-0 backdrop-blur-md'
      }`}
    >
      <div className="mx-auto flex h-[68px] w-full items-center justify-between gap-6 px-4 md:px-8">
        <Link to="/" className="group flex shrink-0 items-center gap-3">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 font-heading text-lg text-background-50">
            禁
          </span>
          <span className="flex flex-col leading-tight">
            <span className={`font-heading text-[15px] tracking-wide md:text-[17px] ${textColor}`}>
              禁止的爱善良的小姨子
            </span>
            <span
              className={`mt-0.5 hidden text-[10px] tracking-[0.28em] sm:block ${
                transparent ? 'text-background-50/60' : 'text-foreground-400'
              }`}
            >
              FORBIDDEN LOVE · DRAMA
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `group relative rounded-md px-4 py-2 text-sm transition-colors ${
                  isActive
                    ? transparent
                      ? 'text-background-50'
                      : 'text-primary-600'
                    : transparent
                      ? 'text-background-50/80 hover:text-background-50'
                      : 'text-foreground-700 hover:text-primary-600'
                }`
              }
            >
              {({ isActive }) => (
                <>
                  {item.label}
                  <span
                    className={`absolute bottom-0.5 left-1/2 h-[2px] w-5 -translate-x-1/2 rounded-full transition-all ${
                      isActive ? 'bg-accent-500 opacity-100' : 'opacity-0'
                    }`}
                  />
                </>
              )}
            </NavLink>
          ))}
        </nav>

        <div className="hidden w-[236px] shrink-0 lg:block">
          <SearchBox tone={transparent ? 'dark' : 'light'} />
        </div>

        <button
          type="button"
          aria-label={menuOpen ? '关闭菜单' : '打开菜单'}
          onClick={() => setMenuOpen((prev) => !prev)}
          className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md border text-xl transition-colors lg:hidden ${
            transparent
              ? 'border-background-50/40 text-background-50'
              : 'border-background-300 text-foreground-800'
          }`}
        >
          <i className={menuOpen ? 'ri-close-line' : 'ri-menu-line'} />
        </button>
      </div>

      {menuOpen && (
        <div className="fixed inset-x-0 top-[68px] bottom-0 z-40 overflow-y-auto border-t border-background-200 bg-background-50 px-4 pb-10 pt-5 lg:hidden animate-fade-in">
          <SearchBox onSubmitted={() => setMenuOpen(false)} />
          <nav className="mt-6 flex flex-col">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `flex items-center justify-between border-b border-background-200 py-4 font-heading text-base transition-colors ${
                    isActive ? 'text-primary-600' : 'text-foreground-800'
                  }`
                }
              >
                <span>{item.label}</span>
                <span className="flex h-4 w-4 items-center justify-center text-sm text-foreground-400">
                  <i className="ri-arrow-right-s-line" />
                </span>
              </NavLink>
            ))}
          </nav>
          <div className="mt-8 rounded-lg bg-background-100 p-4">
            <p className="font-heading text-sm text-foreground-800">禁止的爱 · 善良的小姨子</p>
            <p className="mt-2 text-xs leading-relaxed text-foreground-500">
              一个关于隐瞒、责任与和解的家庭故事。十二集剧情、八位主创、持续更新的幕后动态。
            </p>
          </div>
        </div>
      )}
    </header>
  );
}